import { getStableDeviceId } from '../utils/deviceId'
import { isHighRiskRequest } from './requestSecurityContract'

export async function attachSecurityMeta(config) {
	config.headers = config.headers || {}
	const deviceId = await getStableDeviceId()
	config.headers['X-Device-Id'] = deviceId
	if (!needsSecurityMeta(config)) {
		return config
	}
	if (config.headers['X-Security-Timestamp'] && config.headers['X-Security-Nonce']) {
		return config
	}
	config.headers['X-Security-Timestamp'] = String(Date.now())
	config.headers['X-Security-Nonce'] = createNonce()
	return config
}

function needsSecurityMeta(config) {
	if (!config || config._skipSecurityMeta) {
		return false
	}
	return isHighRiskRequest(config.url)
}

function createNonce() {
	if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
		const bytes = new Uint8Array(16)
		crypto.getRandomValues(bytes)
		return Array.from(bytes, (item) => item.toString(16).padStart(2, '0')).join('')
	}
	return `${Date.now()}${Math.random().toString(16).slice(2, 10)}`
}
